import { Component, OnInit, forwardRef, Input, ElementRef, Renderer, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ValidatorFn, FormGroup, FormControl } from '@angular/forms';
import { BaseAbstractControl } from 'moh-package';

@Component({
  selector: 'moh-gzz-child',
  templateUrl: './gzz-child.component.html',
  styleUrls: ['./gzz-child.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => GzzChildComponent) },
    { provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => GzzChildComponent) }]
})
export class GzzChildComponent extends BaseAbstractControl implements OnInit {

  @Input() firstNameValidators?: ValidatorFn[] = [];
  @Input() lastNameValidators?: ValidatorFn[] = [];
  @Input() idNumberValidators?: ValidatorFn[] = [];
  @Input() birthDateValidators?: ValidatorFn[] = [];

  @Input() firstNameMarkAsRequired?: boolean = false;
  @Input() lastNameMarkAsRequired?: boolean = false;
  @Input() idNumberMarkAsRequired?: boolean = false;
  @Input() birthDateMarkAsRequired?: boolean = false;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {

    this.baseAbstractControl = new FormGroup({

      FirstName: new FormControl('', this.firstNameValidators),
      LastName: new FormControl('', this.lastNameValidators),
      IDNumber: new FormControl('', this.idNumberValidators),
      BirthDate: new FormControl('', this.birthDateValidators)
    });

    super.ngOnInit();
  }

}





// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/general/gzz-child/gzz-child.component.ts